module.exports = __webpack_public_path__ + "img/hanuka_no.7b48cc37.png";